/**
 * Flatten Kendo grid / GroupingEx row trees into leaf data rows for snapshots.
 */
export function flattenRynReplayGridRows(data: unknown): unknown[] {
  if (!Array.isArray(data)) {
    return [];
  }
  const out: unknown[] = [];
  for (const item of data) {
    if (
      item &&
      typeof item === 'object' &&
      Array.isArray((item as { items?: unknown }).items)
    ) {
      out.push(
        ...flattenRynReplayGridRows((item as { items: unknown[] }).items)
      );
      continue;
    }
    out.push(item);
  }
  return out;
}

/** Read the bound row array from a Kendo `grid.data` value. */
export function rowsFromKendoGridData(data: unknown): unknown[] {
  if (!data) {
    return [];
  }
  if (Array.isArray(data)) {
    return flattenRynReplayGridRows(data);
  }
  if (
    typeof data === 'object' &&
    Array.isArray((data as { data?: unknown }).data)
  ) {
    return flattenRynReplayGridRows((data as { data: unknown[] }).data);
  }
  return [];
}
